module.exports = __webpack_public_path__ + "static/media/streamline.17cab4f2.svg";